
import request from '@/utils/request'
import { ENABLE_API_DBG } from '@/appConfig.js';

function list (params) {
  const {max, offset, ...rest} = params;
  const newParams = {take: max, skip: offset, ...rest};
  const qsParams = new URLSearchParams();
  for (let [key, value] of Object.entries(newParams)) {
    if (!Array.isArray(value)) {
      qsParams.append(key, value);
    }
    else {
      value.forEach(elem => qsParams.append(key, elem));
    }
  }
  ENABLE_API_DBG && console.log(`api.organization.list: qsParams = ${qsParams.toString()}`);
  return request({
    url: `/organization?${qsParams.toString()}`,
    method: 'get',
    data: params
  })
}
function get (itemId) {
  return request({
    url: `/organization/${itemId}`,
    method: 'get'
  })
}
function getWithTags (itemId) {
  return request({
    url: `/organization/${itemId}?relation=tags`,
    method: 'get'
  })
}
function getWithGroups (itemId) {
  return request({
    url: `/organization/${itemId}?relation=groups`,
    method: 'get'
  })
}
function search (params) {
  return request({
    url: `/organization/search`,
    method: 'post',
    data: params
  })
}
function add (params) {
  return request({
    url: `/organization`,
    method: 'post',
    data: params
  })
}
function update (params) {
  const {id, ...outParams} = params;
  const url = `/organization/${id}`;
  ENABLE_API_DBG && console.log(`api.organization.update: url = ${url}, outParams = ${JSON.stringify(outParams)}`)
  return request({
    url,
    method: 'patch',
    data: outParams
  })
}
function createSysChannel(id) {
  return request({
    url: `/organization/createSysChannel/${id}`,
    method: 'post'
  })
}
function remove (itemId) {
  return request({
    url: `/organization/${itemId}`,
    method: 'delete'
  })
}
export default {
    list,
    search,
    add,
    update,
    remove,
    get,
    getWithTags,
    getWithGroups,
    createSysChannel
}
